import styled from 'styled-components';
import { Link } from '@trevor/ui-components';

export const CreditCounter = styled.div`
  align-items: center;
  bottom: var(--spacing-s);
  display: flex;
  gap: var(--spacing-s);
  flex-direction: column;
  left: 50%;
  position: absolute;
  transform: translateX(-50%);
`;

export const ChartContainer = styled.div`
  height: 181px;
  position: relative;

  > canvas {
    width: 100%;
  }
`;

export const LearnMore = styled(Link)`
  margin-top: var(--spacing-l);
`;

export const ColumnGap32Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xl);
`;

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 66px;
`;
